<template>
  <div>
    <van-sticky :offset-top="0">
      <demo-block :title="('')">
        <van-nav-bar :title="('充电中')" :left-text="('返回')" left-arrow @click-left="this.$router.go(-1)">
          <template #right>
            <van-icon name="home" size="18" />
          </template>
        </van-nav-bar>
      </demo-block>
    </van-sticky>
    <van-tabs v-model:active="active" sticky>
      <van-pull-refresh
            v-model="isLoading"
            success-text="刷新成功"
            @refresh="onRefresh"
          >
        <van-tab v-for="shop in ordertype" :title="shop.title" :key="shop.id">
          <demo-block>
          

            <van-cell-group v-for="i in lscurorder" :key="i.id" style="margin-bottom:20px;margin-top:5px;" inset>
              <van-cell :title="i.realopfare" :value="i.realopfare" >
                <template #title>
                  <van-tag type="primary" size="large">
                    {{i.termname}} - {{i.portname}}                    
                  </van-tag>
                  <van-icon v-if ="i.stationtype==0" :name="require('../../../assets/images/charge_bike0.png')" color="#9f0000" size="20" style="margin-bottom:-5px;margin-left:20px;margin-top:5px;"/>
                  <van-icon v-else-if ="i.stationtype==1" :name="require('../../../assets/images/charge_car0.png')" color="#9f0000" size="20" style="margin-bottom:-5px;margin-left:20px;margin-top:5px;"/>
                  <van-icon v-else :name="require('../../../assets/images/216.jpg')" color="#9f0000" size="20" style="margin-bottom:-5px;margin-left:20px;margin-top:5px;"/>
                </template>
                <template #value>
                  <van-tag type="warning"  size="large" @click="ShowFareProcess(i)">{{i.realopfare}}</van-tag>
                </template>

              </van-cell>
              <van-cell title="设备位置" :value="i.place"/>
              <van-cell title="客服电话" :value="i.telephone"  />
              <van-cell title="开始时间" :value="i.startdt"  />
              <van-cell title="实时信息" >
                <template #value>
                  <van-tag type="success"  size="mini">{{i.workminute}}分钟</van-tag>
                  <van-tag style="margin-left: 5px;" type="warning"  size="mini">{{i.usekwh/1000}} 度</van-tag>
                </template>
              </van-cell>
              <van-cell title="操作" >
                <template #value>
                  <van-button type="success" icon="info" size="mini" @click="ShowChargeChart(i)">充电情况</van-button>
                  <van-button type="danger" icon="close" size="mini" @click="ShowRemoteOpen(i)" style="margin-left: 5px;">关闭充电</van-button>
                </template>
              </van-cell>
            </van-cell-group>
          </demo-block>
        </van-tab>
      </van-pull-refresh>
    </van-tabs>
    <van-overlay :show="isLoading" >
      <view class="wrapper">
        <view class="block" catch:tap="noop">
          <van-loading size="24px" color="#ffffff">{{loadcontent}}</van-loading>
        </view>
      </view>
    </van-overlay>
    <van-action-sheet v-model:show="showChart" title="使用情况">
      <div style="display: flex;justify-content: center; align-items: center;">
        <van-loading v-if="isLoading" color="#0094ff" size="24px">加载中...</van-loading>
      </div>
      <div class="content">
        <canvas id="myChartElec" height="250"></canvas>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ActionSheet, Divider, PullRefresh, Cell,CellGroup,Checkbox, Button, Dialog, CheckboxGroup, Card, SubmitBar, Toast, Tabs, Tab, Sticky, NavBar, Icon, Tag,  Overlay, Loading } from 'vant';
import { requestChargeIngList, requestChargeClosePort, requestChargeUseChartList } from '../../api/api'
import { mapState, mapGetters, mapActions } from 'vuex'
import F2 from "@antv/f2";

export default {
  components: {
    [Button.name]: Button,
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Sticky.name]: Sticky,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Tag.name]:Tag,
    [Dialog.name]: Dialog,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [PullRefresh.name]:PullRefresh,
    [Divider.name]: Divider,
    [ActionSheet.name]: ActionSheet,
  },
  computed: {
    ...mapState({
      token: state => state.token,
      isbind: state => state.isbind,
      userinfo: state => state.userinfo,
      accesstoken: state => state.accesstoken,
      openid: state => state.openid,
      typekey: state => state.typekey
    }),
    ...mapGetters([
      'openidex',
      'hasopenid',
      'isReAuthLogin',
      'isGrid'
    ])
  },
  data() {
    return {
      fromid: 1,
      toid: 5,
      listCount: 5,
      finished: false,
      loadcontent: '加载中...',
      isLoading: false,
      active: 0,
      lscurorder: [],
      lsorder: [],
      ordertype: [
        { id: 0, key: "all", title: "在充订单", icon: "wap-home" }
      ],
      nTimeDelayInternal: null,
      timeDelay: 60,
      showChart: false,
    }
  },
  watch: {
    active(val) {
      console.log('获得的active发生变化：' + val);
      setTimeout(() => {
        this.fromid = 1
        this.toid = this.listCount
        this.lscurorder = []
        this.finished
        this.GetCurOrderInfo(val);
      }, 300);
    },
  },
  mounted() {
    console.log(this.getLocalLoginInfo())
    setTimeout(() => {
      this.GetCurOrderInfo(0)  
    }, 800)
  },
  methods: {
    ...mapActions([
      'getLocalLoginInfo',
      'getIsNeedAuthLogin',
      'clearAccessToken',
      'getBaseUserInfo'
    ]),
    onLoad() {
      this.isLoading = true
      if (this.finished === true) return
      // console.log('加载数据了，')
      this.fromid = this.toid + 1
      this.toid = this.fromid + this.listCount
      this.GetCurOrderInfo(this.active)
    },
    onRefresh() {
      this.lscurorder = []
      this.fromid = 1
      this.toid =5
      this.finished = false
      this.GetCurOrderInfo(this.active)
    },
    async GetCurOrderInfo (ordertype) {
      this.lscurorder = []
      this.isLoading = true
      const res = await requestChargeIngList({ accesstoken: this.$store.state.accesstoken, ordertype: ordertype, fromid: this.fromid, toid: this.toid})
      console.log(res)
      if (res.return_code === '0') {
        res.data.forEach(info => {
          this.lscurorder.push(info)
        });
        this.isLoading = false
      } else {
          Toast({
              message: res.return_message,
              icon: 'fail',
          });
          this.isLoading = false
      }
       
    },
    onClickLink() {
      Toast('去修改地址去');
    },
    formatPrice(price) {
      return (price / 1).toFixed(2);
    },
    onSubmit() {
      Toast('点击结算');
    },
    ShowFareProcess(i) {
      Toast({
          message: i.fareprocess,
          icon: 'info',
      });
    },
    async ShowRemoteOpen(curS) {
      const r = curS
      console.log(r)
        // 确认关闭
      Dialog.confirm({
        title: '远程确认',
        message: '您确认要远程关闭' + r.termname + '-' + r.portname + ' 电源吗？',
      })
      .then(async () => {
          this.loadcontent = '远程关闭电源中，请稍候...'
          this.isLoading = true
          const res = await requestChargeClosePort({accesstoken: this.$store.state.accesstoken, id: r.poscode, port: r.port})
          if (res.return_code === '0') {
              Toast({
                  message: res.return_message,
                  icon: 'success',
              });
              this.timeDelay=60
              const toast = Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '关闭中 60 秒',
              });
              this.onRefresh()
              this.nTimeDelayInternal=setInterval(() => {
                  this.timeDelay=this.timeDelay-1
                  if (this.timeDelay<=0) {
                    this.timeDelay=0
                    clearInterval(this.nTimeDelayInternal)
                    Toast.clear();
                    this.isLoading = false
                    Dialog.alert({
                      title: '远程操控失败',
                      message: '远程关闭' + r.termname + '-' + r.portname + ' 失败！！！',
                    })
                    return;
                  }
                  // if (this.timeDelay%3!=0) return
                  toast.message = `关闭中，请稍候 ${this.timeDelay} 秒`;
                  this.onRefresh()
                  const a = this.lscurorder.find(item=>item.port==r.port)
                  if(a==undefined || a==null) {
                  clearInterval(this.nTimeDelayInternal)
                  this.isLoading=false
                  Dialog.alert({
                    title: '停止成功',
                    message: '停止插座' + r.termname + '-' + r.portname + '成功！！！',
                  })
                  setTimeout(() => {
                    this.onRefresh()
                    Toast.clear();
                  }, 500);
                  }
              }, 1000);
  
          } else {
              Toast({
                  message: res.return_message,
                  icon: 'fail',
              });
              this.isLoading = false
          }
        });
    },
    async ShowChargeChart(r) {
      console.log(r)
      this.showChart=true
      this.isLoading=true
      setTimeout(async () => {
        await this.ShowChart(r)
        this.isLoading=false
      }, 1000);
    },
    async ShowChart(r) {
      //
      const chartname='myChartElec'
      var c=document.getElementById(chartname);
      console.log(c);
      c.width = document.body.clientWidth;  
      const param = {accesstoken: this.$store.state.accesstoken, id: r.id, port: r.port, type: 1}
      var data = []
      await requestChargeUseChartList(param)
        .then(res => {
          console.log(res);
          if (res.return_code == '0') {
            data = res.data
            if (data.length==0) {
              Toast({
                  message: '无数据',
                  icon: 'info',
              });
              this.showChart=false;
              return;
            }
            const chart = new F2.Chart({
              id: chartname,
              pixelRatio: window.devicePixelRatio
            });
            // console.log(data)
            chart.clear();
            chart.source(data, {
              y: {
                tickCount: 10,
                min: 0,
                formatter: function formatter(val) {
                  return val;
                }
              },
              x: {
                type: 'cat',
                range: [ 0, 1 ],
                tickCount: 6
              }
            });
            chart.axis("x", {
              grid: function grid(text) {
                if (text === 0) {
                  return {
                    lineDash: null,
                  };
                }
              },
            });
            chart.axis("y", {
              grid: function grid(text) {
                if (text === 0) {
                  return {
                    lineDash: null,
                  };
                }
              },
            });
            chart.tooltip({
              showItemMarker: false,
              onShow: function onShow(ev) {
                const items = ev.items;
                items[0].name = null;
                items[0].name = items[0].title;
                items[0].value = " " + items[0].value;
              },
            });
            console.log(chart);
            chart.interaction("pan", {
              limitRange: {
                x: {
                  min: 0,
                  max: 100,
                  tickCount: 5,
                },
              },
            });
            chart.interaction("pinch", {
              maxScale: 5,
              minScale: 1,
              tickCount: 1,
            });
            chart.line().position("x*y").shape("smooth");
            chart.render();
          } else {
            Toast.fail(res.return_message)
          }
          this.isLoading=false
        })
        .catch(() => {
          Toast.success('获取数据失败，请刷新重试')
          this.isLoading=false
        })
        this.isLoading=false
    },
  }
};
</script>

<style lang="less">
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
.card-goods {
  padding: 10px 0;
  background-color: #fff;

  &__item {
    position: relative;
    background-color: #fafafa;

    .van-checkbox__label {
      width: 100%;
      height: auto; // temp
      padding: 0 10px 0 15px;
      box-sizing: border-box;
    }

    .van-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }

    .van-card__price {
      color: #f44;
    }
  }
}
.content {
    padding: 5px 5px 150px;
  }
</style>
